module.exports = __webpack_public_path__ + "img/Credencial-C.86ea08ea.svg";